// extracted by mini-css-extract-plugin
export default {"GoToItem":"GoToItem_GoToItem__YRhTW","Icon":"GoToItem_Icon__-K5H6"};